/* DSD p11dz90 canonical starfield runtime.
 * Replaces legacy #star-background .star DOM regeneration with one stable owner.
 * Build rules: fragment render once, no recurring DOM generation, mobile-scaled, overlay/reduced-motion aware.
 */
(function(){
  'use strict';
  var VERSION = 'p11dz90-canonical-starfield-renderer-v1';
  if (window.DSDStarfieldRenderer && window.DSDStarfieldRenderer.version === VERSION) return;

  var state = {
    version: VERSION,
    booted: false,
    rootId: 'dsd-starfield-root-p11dz90',
    legacyId: 'star-background',
    count: 0,
    reducedMotion: false,
    mobile: false,
    paused: false
  };

  function registry(){ return window.DSDRegistry || window.DSDRuntimeRegistry || null; }
  function claim(surface, owner, meta){
    try { var r = registry(); if (r && typeof r.claim === 'function') r.claim(surface, owner, meta || {}); } catch(e) {}
  }
  function event(type, detail){
    try {
      var r = registry();
      if (r && typeof r.event === 'function') r.event(type, detail || {});
      else if (r && typeof r.track === 'function') r.track(type, detail || {});
    } catch(e) {}
  }

  function ensureRoot(){
    var root = document.getElementById(state.rootId);
    if (!root) {
      root = document.createElement('div');
      root.id = state.rootId;
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('data-dsd-owner', 'StarfieldRenderer');
      root.setAttribute('data-dsd-cosmetic-mutation', 'starfield');
      root.setAttribute('data-dsd-contract', 'canonical-starfield');
      document.body.insertBefore(root, document.body.firstChild || null);
    }
    return root;
  }

  function disableLegacy(){
    var legacy = document.getElementById(state.legacyId);
    if (!legacy) return;
    if (legacy.dataset.dsdLegacyDisabled === VERSION) return;
    legacy.dataset.dsdLegacyDisabled = VERSION;
    legacy.dataset.dsdOwner = 'StarfieldRenderer';
    legacy.dataset.dsdReplacedBy = state.rootId;
    legacy.innerHTML = '';
    legacy.setAttribute('aria-hidden', 'true');
    legacy.style.display = 'none';
    claim('starfield:legacy-dom-disabled', 'StarfieldRenderer', { version: VERSION, selector: '#' + state.legacyId });
  }

  function config(){
    var mobile = (window.innerWidth || 0) < 768;
    state.mobile = mobile;
    state.reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (state.reducedMotion) {
      return { base: mobile ? 42 : 72, hero: mobile ? 5 : 9, drift: mobile ? 5 : 9, cross: mobile ? 2 : 4, dust: mobile ? 8 : 18, shooting: 0 };
    }
    return { base: mobile ? 95 : 150, hero: mobile ? 10 : 18, drift: mobile ? 18 : 32, cross: mobile ? 5 : 9, dust: mobile ? 28 : 60, shooting: mobile ? 2 : 5 };
  }

  function makeStar(type){
    var el = document.createElement('span');
    el.className = 'dsd-starfield-star ' + type;
    el.setAttribute('data-dsd-cosmetic-mutation', 'starfield-star');
    el.style.left = (Math.random() * 100).toFixed(2) + '%';
    el.style.top = (Math.random() * 100).toFixed(2) + '%';
    var duration = type === 'hero' ? 7 + Math.random() * 6 : 4 + Math.random() * 5;
    if (type === 'dust') duration = 12 + Math.random() * 8;
    el.style.animationDuration = duration.toFixed(2) + 's';
    el.style.animationDelay = (-Math.random() * duration).toFixed(2) + 's';
    return el;
  }

  function makeShootingStar(index){
    var el = document.createElement('span');
    el.className = 'dsd-shooting-star dsd-shooting-star--' + index;
    el.setAttribute('data-dsd-cosmetic-mutation', 'shooting-star');
    return el;
  }

  function renderOnce(){
    if (!document.body) return;
    disableLegacy();
    var root = ensureRoot();
    if (root.dataset.dsdRuntime === VERSION) return;

    var cfg = config();
    root.dataset.dsdRuntime = VERSION;
    root.dataset.dsdMobile = state.mobile ? 'true' : 'false';
    root.dataset.dsdReducedMotion = state.reducedMotion ? 'true' : 'false';
    root.textContent = '';

    var frag = document.createDocumentFragment();
    ['base','hero','drift','cross','dust'].forEach(function(type){
      for (var i = 0; i < cfg[type]; i++) frag.appendChild(makeStar(type));
    });
    for (var j = 1; j <= cfg.shooting; j++) frag.appendChild(makeShootingStar(j));
    root.appendChild(frag);

    state.count = root.children.length;
    state.booted = true;
    claim('starfield:canonical-rendered-once', 'StarfieldRenderer', { version: VERSION, count: state.count, mobile: state.mobile, reducedMotion: state.reducedMotion });
    claim('starfield-renderer:asset-global-present', 'StarfieldRenderer', { version: VERSION, globals: ['DSDStarfieldRenderer'] });
    claim('starfield-renderer:anchor-present', 'StarfieldRenderer', { version: VERSION, anchors: ['#' + state.rootId] });
    event('STARFIELD_RENDERER_READY', { version: VERSION, count: state.count });
  }

  function setPaused(paused, reason){
    state.paused = !!paused;
    document.documentElement.classList.toggle('dsd-starfield-paused', state.paused);
    claim('starfield:pause-state', 'StarfieldRenderer', { version: VERSION, paused: state.paused, reason: reason || '' });
  }

  function boot(){
    renderOnce();
  }

  window.DSDStarfieldRenderer = {
    version: VERSION,
    state: state,
    boot: boot,
    pause: function(reason){ setPaused(true, reason || 'manual'); },
    resume: function(reason){ setPaused(false, reason || 'manual'); },
    snapshot: function(){ return JSON.parse(JSON.stringify(state)); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
